import {
  Button,
  createTableColumn,
  DataGrid,
  DataGridBody,
  DataGridCell,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridRow,
  Subtitle2,
  TableColumnDefinition,
  Text,
} from "@fluentui/react-components";
import i18n from "i18next";
import { ISachwert } from "../../Models/ISachwert";
import { useState, useEffect } from "react";
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { baseUrl } from "../../helpers/constants";
import { IArtikel } from "../../Models/IArtikel";
import {
  DocumentArrowRightRegular,
  SearchSettingsRegular,
  ShoppingBagAddRegular,
} from "@fluentui/react-icons";
import { ILSP3ResponseDto } from "../../Models/ILSP3ResponseDto";
import { IAddUserBedarfPosition } from "../../Models/IAddUserBedarfPosition";

interface IShowArticlePage {
  clickedArticle: ILSP3ResponseDto;
  onShowPdf(item: string): void;
  onDownloadKvm(item: string): void;
  onFindAbtriebszahnrad(item: string): void;
  onAddBedarf(item: IAddUserBedarfPosition): void;
}
function ShowArticlePage(props: IShowArticlePage) {
  const [sachwerte, setSachwerte] = useState<ISachwert[] | undefined>(
    undefined,
  );
  const getSachwerte = () => {
    if (props.clickedArticle.artikelId) {
      fetchWrapper
        .postWithAuth(`${baseUrl}/api/sachwert/byquery`, {
          artikelId: props.clickedArticle.artikelId,
        })
        .then((result: ISachwert[]) => {
          setSachwerte(result);
        });
    }
  };
  useEffect(() => {
    getSachwerte();
  }, [props.clickedArticle.artikelId]);
  const columns: TableColumnDefinition<ISachwert>[] = [
    // ------------Artikel------------
    createTableColumn<ISachwert>({
      columnId: "nameDE",
      renderHeaderCell: () => {
        return <Subtitle2> {i18n.t<string>("eigenschaft")}</Subtitle2>;
      },
      renderCell: (item) => {
        return (
          <Text>
            {" "}
            {i18n.language.includes("de") ? item.nameDE : item.nameEN}
          </Text>
        );
      },
    }),
    createTableColumn<ISachwert>({
      columnId: "wert",
      renderHeaderCell: () => {
        return <Subtitle2> {i18n.t<string>("wert")}</Subtitle2>;
      },
      renderCell: (item) => {
        let wert;
        if (item.typ == "NUMBER") {
          wert = parseFloat(item.wert).toLocaleString(undefined, {
            maximumFractionDigits: 3,
          });
        } else {
          wert = i18n.language.includes("de") ? item.wertDE : item.wertEN;
        }
        return (
          <div>
            <Text>{wert}</Text>
          </div>
        );
      },
    }),

    createTableColumn<ISachwert>({
      columnId: "mengeneinheit",
      renderHeaderCell: () => {
        return <Subtitle2> {i18n.t<string>("mengeneinheit")}</Subtitle2>;
      },
      renderCell: (item) => {
        let wert;
        if (item.typ == "NUMBER") {
          wert = parseFloat(item.wert).toLocaleString(undefined, {
            maximumFractionDigits: 3,
          });
        } else {
          wert = i18n.language.includes("de") ? item.wertDE : item.wertEN;
        }
        return (
          <div>
            <Text>{item.mengeneinheit}</Text>
          </div>
        );
      },
    }),
  ];
  let benennung = "";

  if (i18n.language.includes("de")) {
    benennung = props.clickedArticle.artikel
      ? props.clickedArticle.artikel.benennungDE
      : props.clickedArticle.benennungDE;
  } else {
    benennung = props.clickedArticle.artikel
      ? props.clickedArticle.artikel.benennungEN
      : props.clickedArticle.benennungEN;
  }

  if (sachwerte != undefined) {
    return (
      <>
        {(props.clickedArticle.isErsatz == true ||
          props.clickedArticle.artikel?.isErsatz == true) && (
          <div className="lueb-InnerContentBlockPadding2px">
            <Button
              appearance="transparent"
              onClick={() => {
                props.onAddBedarf({
                  artikel: props.clickedArticle.artikelId,
                  produkt: undefined,
                  benennung: benennung,
                  kundenReferenz:
                    "Quick Finder " + new Date().toLocaleDateString(),
                  menge: 1,
                  reference: undefined,
                });
              }}
              icon={<ShoppingBagAddRegular />}
            >
              {i18n.t<string>("addToBedarf")}
            </Button>
            {props.clickedArticle.hasPrzDocument && (
              <Button
                icon={<DocumentArrowRightRegular />}
                appearance="transparent"
                onClick={() => {
                  props.onShowPdf(props.clickedArticle.artikelId);
                }}
              >
                {i18n.t<string>("showPRZ")}
              </Button>
            )}
            {props.clickedArticle.hasKvmDocument && (
              <Button
                icon={<DocumentArrowRightRegular />}
                appearance="transparent"
                onClick={() => {
                  props.onDownloadKvm(props.clickedArticle.artikelId);
                }}
              >
                {i18n.t<string>("downloadKvm")}
              </Button>
            )}
            {(props.clickedArticle.sachgruppe?.name == "Flachabtrieb" ||
              props.clickedArticle?.artikel?.sachgruppe?.name ==
                "Flachabtrieb") && (
              <Button
                icon={<SearchSettingsRegular />}
                appearance="transparent"
                onClick={() => {
                  props.onFindAbtriebszahnrad(props.clickedArticle.artikelId);
                }}
              >
                {i18n.t<string>("getAbtriebszahnraeder")}
              </Button>
            )}
          </div>
        )}
        <div className="lueb-ContentBlock">
          <DataGrid items={sachwerte ?? []} columns={columns}>
            <DataGridHeader>
              <DataGridRow>
                {({ renderHeaderCell }) => (
                  <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                )}
              </DataGridRow>
            </DataGridHeader>
            <DataGridBody<ISachwert[]>>
              {({ item, rowId }) => (
                <DataGridRow<ISachwert[]> key={rowId}>
                  {({ renderCell }) => (
                    <DataGridCell>{renderCell(item)}</DataGridCell>
                  )}
                </DataGridRow>
              )}
            </DataGridBody>
          </DataGrid>
        </div>
      </>
    );
  } else return <></>;
}
export default ShowArticlePage;
